import { ref } from 'vue'
export function useMedia() {

    const fetchVendorLogo = async (vendorId) => {
        try {
            const response = await fetch(`/media/vendor/${vendorId}/logo`)
            if (response.ok) {
                return await response.text()
            } else {
                return null
            }
        } catch (error) {
            console.error('Error fetching vendor logo:', error)
            return null
        }
    }

    const fetchVendorCover = async (vendorId) => {
        try {
            const response = await fetch(`/media/vendor/${vendorId}/cover`)
            if (response.ok) {
                return await response.text()
            } else {
                return null
            }
        } catch (error) {
            console.error('Error fetching vendor cover:', error)
            return null
        }
    }

    const fetchVendorGallery = async (vendorId) => {
        try {
            const response = await fetch(`/media/vendor/${vendorId}/gallery`)
            if (response.ok) {
                return await response.json()
            } else {
                return []
            }
        } catch (error) {
            console.error('Error fetching vendor gallery:', error)
            return []
        }
    }

    const fetchItemPhoto = async (itemId) => {
        try {
            const response = await fetch(`/media/item/${itemId}/photo`)
            if (response.ok) {
                return await response.text()
            } else {
                return null
            }
        } catch (error) {
            console.error('Error fetching item photo:', error)
            return null
        }
    }

    return {
        fetchVendorLogo,
        fetchVendorCover,
        fetchVendorGallery,
        fetchItemPhoto,
    }
}
